import React, { useState, useEffect } from "react";

const Correlation = (value) => {
  const [radioState, setRadioState] = useState("spearman");

  var noEtaIndex = 0;
  var noIndex = 0;
  const createIndex = (value) => {
    if (value === "Eta") noEtaIndex = noEtaIndex + 1;
    else noIndex = noIndex + 1;
  };

  const tbColor = (data, index) => {
    var compare_Y = Number(
      value.data.main_db.correlation_analysis.q95[index] * 100
    ).toFixed(1);
    var compare_O = Number(
      value.data.main_db.correlation_analysis.q975[index] * 100
    ).toFixed(1);
    var compare_G = Number(
      value.data.main_db.correlation_analysis.q995[index] * 100
    ).toFixed(1);

    if (data < 100) {
      if (compare_Y <= Math.abs(data) && Math.abs(data) < compare_O) {
        return { background: "#ffff00" };
      }

      if (compare_O <= Math.abs(data) && Math.abs(data) < compare_G) {
        return { background: "#ffc000" };
      }

      if (Math.abs(data) > compare_G) {
        return { background: "#92d050" };
      }
    } else {
      return { background: "#e3e3e3" };
    }
  };

  const changeRadioState = (value) => {
    localStorage.setItem("correlationRadioInfo", JSON.stringify(value));
    setRadioState(value);
  };

  useEffect(() => {
    const radio_state = JSON.parse(
      localStorage.getItem("correlationRadioInfo")
    );
    if (radio_state) setRadioState(radio_state);
  }, []);

  return (
    <div>
      <div className="container">
        <div>
          <div className="correlation_details_container cd-flex">
            <div className="option-border">
              <div>
                <label className="d-flex mr-2">
                  <input
                    type="radio"
                    onChange={(e) => changeRadioState("spearman")}
                    checked={radioState === "spearman"}
                  />
                  <div className="ml-1">Spearman Rho correlation matrix</div>
                </label>
              </div>
              <div>
                <label className="d-flex mr-2">
                  <input
                    type="radio"
                    onChange={(e) => changeRadioState("eta")}
                    checked={radioState === "eta"}
                  />
                  <div className="ml-1">Eta correlation matrix</div>
                </label>
              </div>
              <div>
                <label className="d-flex">
                  <input
                    type="radio"
                    onChange={(e) => changeRadioState("both")}
                    checked={radioState === "both"}
                  />
                  <div className="ml-1">Both correlation matrix</div>
                </label>
              </div>
            </div>

            <div>
              <div>
                <div>Legend:</div>
                <div style={{ background: "#92d050" }}>
                  Value significant at the 99% confidence level
                </div>
                <div style={{ background: "#ffc000" }}>
                  Value significant at the 95% confidence level
                </div>
                <div style={{ background: "#ffff00" }}>
                  Value significant at the 90% confidence level
                </div>
              </div>
              <div className="d-flex justify-content-end mt-3">
                <a
                  className="help-link"
                  href="#!"
                  onClick={
                    () => window.parent.postMessage({
                      cmd: "hyperlink",
                      url: "https://logratio.com/users-guide/#correlation-analysis"
                    }, "https://logratio.com")
                  }
                >
                  Help with this analysis
                </a>
              </div>
            </div>
          </div>

          {radioState === "spearman" || radioState === "both" ? (
            <div className="correlation_table_content">
              <div>
                <strong style={{ fontSize: "16px" }}>
                  Correlation matrix : Spearman Rho (%)
                </strong>
              </div>
              <table className="correlation-table">
                <thead>
                  <tr>
                    <th className="col"></th>
                    {value.data.main_db.questions.map((items, index) => (
                      <>
                        {items.is_closed ? (
                          <th key={index} className="table_th_top col">
                            {items.desc}
                          </th>
                        ) : null}
                      </>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {value.data.main_db.questions.map((items, index) => (
                    <>
                      {items.is_closed ? (
                        <tr key={index}>
                          <>{createIndex()}</>
                          <th key={index} className="table_th_left">
                            {items.desc}
                          </th>
                          {value.data.main_db.correlation_analysis.spearman_rho.map(
                            (rho_item, rho_index) => (
                              <td
                                key={rho_index}
                                style={tbColor(
                                  Number(rho_item[noIndex - 1] * 100).toFixed(
                                    1
                                  ),
                                  index
                                )}
                              >
                                {Number(rho_item[noIndex - 1] * 100).toFixed(
                                  1
                                ) < 100
                                  ? Number(rho_item[noIndex - 1] * 100).toFixed(
                                    1
                                  )
                                  : null}
                              </td>
                            )
                          )}
                        </tr>
                      ) : null}
                    </>
                  ))}
                </tbody>
                <tfoot></tfoot>
              </table>
            </div>
          ) : null}

          {radioState === "eta" || radioState === "both" ? (
            <div className="correlation_table_content">
              <div>
                <strong style={{ fontSize: "16px" }}>
                  Correlation matrix : Eta (%)
                </strong>
              </div>
              <table className="correlation-table">
                <thead>
                  <tr>
                    <th className="col"></th>
                    {value.data.main_db.questions.map((items, index) => (
                      <>
                        {items.is_closed ? (
                          <th key={index} className="table_th_top col">
                            {items.desc}
                          </th>
                        ) : null}
                      </>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {value.data.main_db.questions.map((items, index) => (
                    <>
                      {items.is_closed ? (
                        <tr key={index}>
                          <>{createIndex("Eta")}</>
                          <th key={index} className="table_th_left">
                            {items.desc}
                          </th>
                          {value.data.main_db.correlation_analysis.eta.map(
                            (eta_item, eta_index) => (
                              <td
                                key={eta_index}
                                style={tbColor(
                                  Number(
                                    eta_item[noEtaIndex - 1] * 100
                                  ).toFixed(1),
                                  index
                                )}
                              >
                                {Number(eta_item[noEtaIndex - 1] * 100).toFixed(
                                  1
                                ) < 100
                                  ? Number(
                                    eta_item[noEtaIndex - 1] * 100
                                  ).toFixed(1)
                                  : null}
                              </td>
                            )
                          )}
                        </tr>
                      ) : null}
                    </>
                  ))}
                </tbody>
                <tfoot></tfoot>
              </table>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Correlation;
